// Exchange rate configuration
// Demo rates - in production, fetch from API
export const FX_CONFIG = {
  USD_TO_AED: 3.67,
  USD_TO_KES: 128.5,
  USD_TO_UGX: 3750,
  USD_TO_TZS: 2550,
  USD_TO_ETB: 56.5,
  USD_TO_RWF: 1320,
  disclaimer: "Demo exchange rates used for display only."
};

export const formatUSD = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

export const formatCurrency = (amount, currency) => {
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency,
    minimumFractionDigits: currency === 'UGX' ? 0 : 2,
    maximumFractionDigits: currency === 'UGX' ? 0 : 2
  }).format(amount);
};

export const convertFromUSD = (usdAmount, currency) => {
  switch (currency) {
    case 'USD':
      return usdAmount;
    case 'AED':
      return usdAmount * FX_CONFIG.USD_TO_AED;
    case 'KES':
      return usdAmount * FX_CONFIG.USD_TO_KES;
    case 'UGX':
      return usdAmount * FX_CONFIG.USD_TO_UGX;
    case 'TZS':
      return usdAmount * FX_CONFIG.USD_TO_TZS;
    case 'ETB':
      return usdAmount * FX_CONFIG.USD_TO_ETB;
    case 'RWF':
      return usdAmount * FX_CONFIG.USD_TO_RWF;
    default:
      return usdAmount;
  }
};

export const formatDualCurrency = (usdAmount) => {
  const aedAmount = convertFromUSD(usdAmount, 'AED');
  return {
    usd: formatUSD(usdAmount),
    aed: formatCurrency(aedAmount, 'AED'),
    combined: `${formatUSD(usdAmount)} (${formatCurrency(aedAmount, 'AED')})`
  };
};
